import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const d=i("bonaire",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M24 4.5L24 20.5L0 20.5L24 4.5Z"
                fill="#003087" />
            <path
                d="M0 11.1667L0 4.5L10 4.5L0 11.1667Z"
                fill="#FFD700" />
            <path
                d="M9.68441 11.2703L12 10.0974L9.68441 8.92442L8.34766 6.89258L7.0109 8.92442L4.69531 10.0974L7.0109 11.2703L8.34766 13.3022L9.68441 11.2703Z"
                fill="#101820" />
            <path
                d="M8.34652 12.873C10.0934 12.873 11.5095 11.6304 11.5095 10.0976C11.5095 8.56484 10.0934 7.32227 8.34652 7.32227C6.59969 7.32227 5.18359 8.56484 5.18359 10.0976C5.18359 11.6304 6.59969 12.873 8.34652 12.873Z"
                fill="#101820" />
            <path
                d="M8.34717 12.5015C9.86002 12.5015 11.0864 11.4254 11.0864 10.0979C11.0864 8.77047 9.86002 7.69434 8.34717 7.69434C6.83432 7.69434 5.60791 8.77047 5.60791 10.0979C5.60791 11.4254 6.83432 12.5015 8.34717 12.5015Z"
                fill="white" />
            <path
                d="M9.40181 10.0975L9.92937 9.29632H8.87506L8.3475 8.49512L7.81994 9.29632H6.76562L7.29319 10.0975L6.76562 10.8987H7.81994L8.3475 11.6999L8.87506 10.8987H9.92937L9.40181 10.0975Z"
                fill="#D50032" />
        </svg>
    `),a=i("bonaire_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92919)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M24 0.5L24 24.5L0 24.5L24 0.5Z"
                    fill="#003087" />
                <path
                    d="M0 10.5L0 0.5L10 0.5L0 10.5Z"
                    fill="#FFD700" />
                <path
                    d="M10.3049 11.1389L13.6953 9.18164L10.3049 7.2244L8.34766 3.83398L6.39041 7.2244L3 9.18164L6.39041 11.1389L8.34766 14.5293L10.3049 11.1389Z"
                    fill="#101820" />
                <path
                    d="M8.34591 13.8129C10.9036 13.8129 12.977 11.7395 12.977 9.18185C12.977 6.62418 10.9036 4.55078 8.34591 4.55078C5.78824 4.55078 3.71484 6.62418 3.71484 9.18185C3.71484 11.7395 5.78824 13.8129 8.34591 13.8129Z"
                    fill="#101820" />
                <path
                    d="M8.34668 13.1924C10.5618 13.1924 12.3574 11.3967 12.3574 9.18164C12.3574 6.96657 10.5618 5.1709 8.34668 5.1709C6.13161 5.1709 4.33594 6.96657 4.33594 9.18164C4.33594 11.3967 6.13161 13.1924 8.34668 13.1924Z"
                    fill="white" />
                <path
                    d="M9.89107 9.18164L10.6635 7.84473L9.11982 7.84473L8.34738 6.50781L7.57494 7.84473H6.03125L6.80369 9.18164L6.03125 10.5186H7.57494L8.34738 11.8555L9.11982 10.5186H10.6635L9.89107 9.18164Z"
                    fill="#D50032" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92919">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Bonaire,a as BonaireRounded};
